import React from "react";
import { observer } from "mobx-react";
import { useLocation } from "react-router-dom";
import copilotStore from "Stores/copilotStore";
import {
  getCopilotContext,
  sectionKeyOf,
  sectionLabel
} from "Pages/Dashboard/Copilot/agent/copilotContext";

/*
 * The receipt: what this conversation is actually using.
 *
 * Sections get here by being ASKED FROM, never by being visited, so this is a
 * record of the user's own actions rather than a guess about their intent.
 * The section they are standing on is pinned -- dropping the page you are
 * looking at would only re-attach on the next message, so offering it would
 * be a lie.
 */
const AttachReceipt = observer(() => {
  // Subscribed purely so the pinned chip re-resolves on navigation --
  // getCopilotContext reads window.location itself.
  useLocation();
  const attached = copilotStore.attachedSections;
  const context = getCopilotContext();
  const currentKey = sectionKeyOf(context);
  // The page you are standing on is always sent with the message, so it always
  // belongs on the receipt -- it used to appear only if it happened to have
  // been asked from, which meant that after navigating the receipt named the
  // page you had LEFT and never the one you were looking at.
  const sections = currentKey
    ? [
        { key: currentKey, label: sectionLabel(context), pathname: "" },
        ...attached.filter(s => s.key !== currentKey)
      ]
    : attached;
  // Nothing to account for yet on a fresh chat that has not been used.
  if (!attached.length && !copilotStore.messages.length) return null;
  if (!sections.length) return null;

  return (
    <div className="cdReceipt">
      <span className="cdReceipt__label">Using</span>
      {sections.map(section => {
        const pinned = section.key === currentKey;
        return (
          <span
            key={section.key}
            className={`cdReceipt__chip${pinned ? " cdReceipt__chip--pinned" : ""}`}
            title={
              pinned
                ? `${section.label} — the page you are on`
                : section.pathname
            }
          >
            {section.label}
            {!pinned && (
              <button
                type="button"
                className="cdReceipt__drop"
                aria-label={`Stop using ${section.label}`}
                onClick={() => copilotStore.dropSection(section.key)}
              >
                <i className="material-icons-outlined">close</i>
              </button>
            )}
          </span>
        );
      })}
    </div>
  );
});

export default AttachReceipt;
